document.addEventListener("DOMContentLoaded", function () {

  // 黒帯バナー
    // console.log('HEADER START');
    const banner = document.querySelector('.header-banner');
    // console.log('banner', banner);
    if (!banner) return;
    const items = banner.querySelectorAll('.header-banner__item');
    // console.log('items', items.length);
    if (items.length < 2) return;
    let current = 0;
    setInterval(() => {
      // console.log('change', current);
      items[current].classList.remove('is-active');
      current = (current + 1) % items.length;
      items[current].classList.add('is-active');
      // console.log(
      //   [...items].map(item => item.className)
      // );
    }, 6000);


  // チャネルトーク非表示
  if (window.location.pathname.includes("/blogs/feature")) {
    document.body.classList.add("is_hide_channeltalk");
  }

    const now = new Date();
    
    document.querySelectorAll(".time-content").forEach(el => {
      const startStr = el.dataset.start;
      const endStr   = el.dataset.end;

      const startDate = new Date(startStr.replace(" ", "T"));
      const endDate   = new Date(endStr.replace(" ", "T"));

      if (now >= startDate && now <= endDate) {
        el.style.display = "block";
      } else {
        el.style.display = "none";
      }
    });


    // userAgent を取得
    var userAgent = navigator.userAgent || '';
    
    // userAgent に "Appify" という文字列が含まれているかを判定
    if (userAgent.indexOf('Appify') !== -1) {
      // bodyにクラスを追加
      document.body.classList.add('is-appify');
    }

   
  // ヘッダーブランドメニュー
  const brandMenus = document.querySelectorAll('.header__linklist-item.header-brand-menu');

  // スクロール時の共通処理
  function handleScroll(submenu) {
    // 自身の is-arrow
    if (submenu.classList.contains('is-arrow')) {
      submenu.classList.add('is-hide');
    }

    // 子要素の is-arrow
    submenu.querySelectorAll('.is-arrow').forEach(el => {
      el.classList.add('is-hide');
    });
  }

  brandMenus.forEach(menu => {
    const link = menu.querySelector('.header__linklist-link');
    const submenu = menu.querySelector('.header-bm');

    // ▼ここで li.is-icon を監視
    const iconItem = submenu.querySelector('.header-bm-item.is-icon');
    if (iconItem) {
      iconItem.addEventListener('click', function(e) {
        e.preventDefault();
        submenu.scrollTo({
          top: submenu.scrollHeight,
          behavior: 'smooth'
        });
      });
    }

    link.addEventListener('click', function(event) {
      event.preventDefault();

      // 他のメニューを閉じる
      brandMenus.forEach(m => {
        const sub = m.querySelector('.header-bm');
        if (sub !== submenu) {
          sub.classList.remove('is-open');
          sub.removeEventListener('scroll', sub._handleScroll); // 登録済みイベント解除
        }
      });

      // 現在のメニューをトグル
      const isOpen = submenu.classList.toggle('is-open');

      // bodyクラス付与/削除
      if (isOpen) {
        document.body.classList.add('hbm-open');

        // 開いたらスクロールイベントを登録
        submenu._handleScroll = () => handleScroll(submenu); // submenuごとにラップ
        submenu.addEventListener('scroll', submenu._handleScroll);
      } else {
        document.body.classList.remove('hbm-open');
        submenu.removeEventListener('scroll', submenu._handleScroll);
      }
    });
  });

  // body クリックでメニューを閉じる
  document.addEventListener('click', function(event) {
    const isClickInsideMenu = event.target.closest('.header__linklist-item.header-brand-menu');

    if (!isClickInsideMenu) {
      brandMenus.forEach(menu => {
        const submenu = menu.querySelector('.header-bm');
        submenu.classList.remove('is-open');
        submenu.removeEventListener('scroll', submenu._handleScroll);
      });
      document.body.classList.remove('hbm-open');
    }
  });



  // STST 利用しているブランドのみを表示
  if (window.location.pathname.includes("/apps/staffstart/")) {
    function addClassStstnav() {
      document.querySelectorAll(".sc-dlWCHZ .sc-hHOBiw").forEach((el, index) => {
        if (!el.classList.contains("processed")) {
          var className = "ststNav_" + (index + 1).toString().padStart(2, "0");
          el.classList.add(className);
        }
      });
      addClassStstbrands();
      removeoptionSPbrands();
    }

    function addClassStstbrands() {
      document.querySelectorAll(".sc-dlWCHZ .sc-hHOBiw").forEach((navEl) => {
        let classNames = [...navEl.classList].filter(cls => cls.startsWith("ststNav_"));
        classNames.forEach(className => {
          document.querySelectorAll(`.${className} .sc-ecPEgm li a`).forEach((el) => {
            if (!el.classList.contains("processed")) {
              var text = el.textContent;
              var alphanumericText = text
                .replace(/[^a-zA-Z0-9\s]/g, "")
                .replace(/\s+/g, "")
                .toLowerCase();
              if (alphanumericText) {
                el.closest("li").classList.add(alphanumericText);
              }
            }
          });
        });
      });
    }

    function removeoptionSPbrands() {
      const valuesToHide = ["Alunc", "and wander", "ATHLETIG", "ELE STOLYOF", "FLOML", "GARDEN", "HAVEL studio",
      "MARGARET HOWELL", "MHL.", "nano universe GOLF", "NBB WEEKEND", "PEARLY GATES", "PGG", "PING", "Public Drip", "quitan",
      "S+", "SEVEN BY SEVEN", "Students Golf", "THE LIBRARY", "TSI", "TSI MALL", "wagona", "YLÈVE", "YOKE", "1533", "1540",]

      valuesToHide.forEach(function(value) {
        const option = document.querySelector(`.sc-dPZUQH.iLehxE option[value="${value}"]`);
        if (option) {
          option.remove();
        }
      });
    }

    addClassStstnav();
    const observer = new MutationObserver(() => {
      addClassStstnav();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (window.location.pathname.includes("/apps/staffstart/articles")) {
    document.body.classList.add("is_blogpage");
  }


  // Boost AI 検索結果0ページ スライダー調整,検索結果の文字列変更
  if (window.location.pathname.includes("/search")) {

    let sliderInitialized = false;
    let observer = null;

    function resultKeywordChange() {
     const titleElement = document.querySelector('.boost-sd__search-form-title');
     if (!titleElement) return; // ZETA検索ページにはBoost要素が無いため

     let titleText = titleElement.innerHTML;
     console.log(titleText);
     // titleText = titleText.replace(/{{\s*terms\s*}}#39;/g, "'");
     // titleElement.innerHTML = titleText;
    }

    function resetslideroption() {
      const noSearchResultSlider = document.querySelector(".boost-sd__no-search-result-page-popular-products .slick-slider");

      if (noSearchResultSlider) {
        if (!sliderInitialized) {
          // 1回だけスライダーを削除 & 再生成
          if ($(noSearchResultSlider).hasClass("slick-initialized")) {
            $(noSearchResultSlider).slick("unslick");
            // console.log("スライダーを初期化解除");
          }

          $(noSearchResultSlider).slick({
            slidesToShow: 5,
            slidesToScroll: 5,
            infinite: true,
            dots: false,
            arrows: false,
            autoplay: false,
            responsive: [
             {
               breakpoint: 991,
               settings: {
                 slidesToShow: 2,
                 slidesToScroll: 2
               }
             }
           ]
          });

          // console.log("スライダーを再生成しました");
          sliderInitialized = true;

          // MutationObserverを停止する
          if (observer) {
            observer.disconnect();
            // console.log("MutationObserverを停止しました");
          }
        }
      } else {
        return false;
      }
    }

    // jQueryの読み込み
    const jquery = document.createElement("script");
    jquery.src = "https://code.jquery.com/jquery-3.6.0.min.js";
    jquery.onload = function () {
      // console.log("jQueryが読み込まれました");

      // jQuery 読み込み完了後に MutationObserverを開始
      observer = new MutationObserver(() => {
        resultKeywordChange();
        resetslideroption();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      resultKeywordChange();
      // 初回のスライダー処理を実行
      resetslideroption();
    };
    jquery.onerror = function () {
      // console.error("jQueryの読み込みに失敗しました。");
    };
    document.head.appendChild(jquery);
  }

});


// Boost置換
(function(){
  const MAP = {
    'NEW': '新着',
    'Pre-order': '予約'
  };

  function translateRefineBy() {
    document.querySelectorAll('.boost-sd__refine-by-vertical-refine-by-value').forEach(el => {
      const raw = el.textContent.trim();
      if (MAP[raw]) el.textContent = MAP[raw];
    });
  }

  // 初回
  translateRefineBy();

  // Boost再描画対応
  [
    'boost-sd:rendered',
    'boost-sd:filters-rendered',
    'boost-sd:collection-rendered',
    'boost-sd:search-rendered'
  ].forEach(ev => document.addEventListener(ev, translateRefineBy));

  // DOM変化検知
  const mo = new MutationObserver(translateRefineBy);
  mo.observe(document.body, { childList: true, subtree: true });
})();